var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivitySolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.49 7.80863V7.81V16.19C21.49 17.9106 20.9791 19.2238 20.0964 20.1064C19.2138 20.9891 17.9006 21.5 16.18 21.5H7.81C6.08945 21.5 4.77634 20.9891 3.89377 20.1054C3.01114 19.2217 2.5 17.9059 2.5 16.18V7.81C2.5 6.08944 3.01093 4.77618 3.89355 3.89355C4.77618 3.01093 6.08944 2.5 7.81 2.5H16.19C17.9107 2.5 19.2237 3.01097 20.105 3.89333C20.9861 4.77559 21.4947 6.08838 21.49 7.80863ZM15.3435 13.2484L15.3452 13.2463L17.654 10.2678C17.6542 10.2676 17.6543 10.2674 17.6545 10.2672C18.0821 9.71925 17.9629 8.94359 17.4366 8.51302L17.4353 8.51194C16.894 8.07218 16.0926 8.175 15.6734 8.72556L13.5129 11.5126L11.8792 10.2271L11.8784 10.2265C11.4046 9.85511 10.8011 9.68686 10.2067 9.76403C9.60194 9.84123 9.07489 10.1515 8.70647 10.6216L8.70646 10.6215L8.70388 10.6249L6.32388 13.7149L6.32387 13.7149L6.32145 13.7181C5.90914 14.2623 6.00289 15.0449 6.55455 15.4659C6.78538 15.646 7.05386 15.73 7.32 15.73C7.69114 15.73 8.05646 15.5614 8.30244 15.2498L8.30247 15.2498L8.30612 15.2451L10.5377 12.3478L12.1708 13.6329L12.1716 13.6335C12.6439 14.0038 13.2354 14.1722 13.8381 14.0966C14.4486 14.0302 14.9765 13.7167 15.3435 13.2484Z",
    fill: "#E7E9F1",
    stroke: "#E7E9F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySolid);
export default __webpack_public_path__ + "static/media/activity-solid.c34641e63affa41e66311bb31dcc468f.svg";
export { ForwardRef as ReactComponent };